import { render } from "./App.vue?vue&type=template&id=460d93b6&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=460d93b6&lang=sass"
import "./App.vue?vue&type=style&index=1&id=460d93b6&scoped=true&lang=sass"

import exportComponent from "/Users/sotenck/GIT/kunden/iconomy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-460d93b6"]])

export default __exports__